<div class="container blockFlex" style="display: flex; margin-bottom: 15px">
  <div class="col-md-6 mt-5 plr-5" *ngFor="let subCard of salesHubCategory">
    <div class="note text-center pb-20">
      <p>
        <small>{{ subCard.title }}</small>
      </p>
      <div class="button-center">
        <a class="ba-btn" [href]="subCard.buttonUrl" role="button" target="_blank"> {{ subCard.buttonText }}</a>
      </div>
    </div>
  </div>
</div>
